import axios from 'axios'

// 设置留言
export function imNoteSet (datas) {
  const url = `/noteInfo/imNoteSet`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取IM留言设置信息
export function queryImNoteSet (datas) {
  const url = `/noteInfo/queryImNoteSet`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取留言列表
export function queryNoteInfoPage (datas) {
  const url = `/noteInfo/queryNoteInfoPage`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 留言列表导出
export function exportNoteInfo (datas) {
  const url = `/noteInfo/exportNoteInfo`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 设置IM留言设置处理状态
export function imNoteRecordSetHanderStatus (datas) {
  const url = `/noteInfo/imNoteRecordSetHanderStatus`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取留言详情
export function queryIMNoteRecordById (datas) {
  const url = `/noteInfo/queryIMNoteRecordById`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取留言默认分配客服信息
export function queryAutoMessagePolicy (datas) {
  const url = `/noteInfo/queryAutoMessagePolicy`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 设置留言自动分配客服
export function setAutoMessagePolicy (datas) {
  const url = `/noteInfo/setAutoMessagePolicy`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 添加留言跟进记录
export function addImNoteFollowUpRecord (datas) {
  const url = `/noteInfo/addImNoteFollowUpRecord`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取青豆网课服务号带参数的永久二维码
export function queryQRCodeWithParames (datas) {
  const url = `/noteInfo/queryQRCodeWithParames`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/message/index.js